import script from "./ReferralCode.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferralCode.vue?vue&type=script&setup=true&lang=js"

import "./ReferralCode.vue?vue&type=style&index=0&id=5c502306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c502306"]])

export default __exports__